import { GetSellSpecialtyItems } from "./getSellSpecialtyItems";
import { DEFAULT_PAGE } from "../../contstants";

const FilterSellSpecialtyItems = async (perPage, filters) => {
  const page = filters.page || DEFAULT_PAGE;
  const name = filters.s || "";

  let isActive = null;
  if (filters.status === "active") {
    isActive = true;
  }
  if (filters.status === "inactive") {
    isActive = false;
  }

  return await GetSellSpecialtyItems({ page, perPage, name, isActive });
};

export default FilterSellSpecialtyItems;
